import BlogPage from "./BlogPage";
export default BlogPage;